import { ManageQuestionsNewLabel } from './manage-questions-new-label';

let manageQuestionsNewLabel: ManageQuestionsNewLabel | null = null;

const getManageQuestionsNewLabel = (): ManageQuestionsNewLabel => {
  if(manageQuestionsNewLabel == null) {
    manageQuestionsNewLabel = new ManageQuestionsNewLabel();
  }

  return manageQuestionsNewLabel;
};

export { getManageQuestionsNewLabel };